import type { TabsProps } from 'antd'
import { Tabs } from 'antd'
import './index.less'
import { observer } from 'mobx-react'
import useStore from '@/hooks/useStore'
import FacilityPopulationTabs from '@/components/Content/FacilityAmbientAnalysis/FacilityPopulationTabs'
import FacilityAroundTabs from '@/components/Content/FacilityAmbientAnalysis/FacilityAroundTabs'
import FacilityBuildingTabs from '@/components/Content/FacilityAmbientAnalysis/FacilityBuildingTabs'
import FacilityTrafficTabs from '@/components/Content/FacilityAmbientAnalysis/FacilityTrafficTabs'
import FacilityBusinessTabs from '@/components/Content/FacilityAmbientAnalysis/FacilityBusinessTabs'
import FacilityTourismTabs from '@/components/Content/FacilityAmbientAnalysis/FacilityTourismTabs'

function FacilityAmbientAnalysis() {
  const uiStore = useStore('uiStore')
  const facilityStore = useStore('facilityStore')
  const tabsArr: TabsProps['items'] = [
    {
      key: '1',
      label: '인구정보',
      children: <FacilityPopulationTabs/>,
    },
    {
      key: '2',
      label: '주변환경',
      children: <FacilityAroundTabs/>,
    },
    {
      key: '3',
      label: '주요시설',
      children: <FacilityBuildingTabs/>,
    },
    {
      key: '4',
      label: '교통정보',
      children: <FacilityTrafficTabs/>,
    },
    {
      key: '5',
      label: '사업체정보',
      children: <FacilityBusinessTabs/>,
    },
    {
      key: '6',
      label: '관광정보',
      children: <FacilityTourismTabs/>,
    },
  ]

  const hideCilck = () => {
    facilityStore.closeCurrentPage()
  }

  return (
    <div className={'FacilityAmbientAnalysis'} style={{ height: uiStore.uiHeight }}>
      <div className={'content'}>
        <div className={'title'}>
          <strong>주변분석</strong>
        </div>
        <div className={'TabPart'}>
          <Tabs centered size={'large'} defaultActiveKey="1" items={tabsArr} />
        </div>
      </div>
      {/* <div className={'HideButton'}>
              <button onClick={hideCilck} className={'btn-fold'}/>
          </div> */}
      {facilityStore.isOpendTabsPage === true
        ? <div className={'HideButton'}>
          <button className={'btn-fold'} onClick={hideCilck} />
        </div>
        : <div className={'HideButton'}>
          <button className={'btn-open'} onClick={hideCilck} />
        </div>}
    </div>
  )
}

export default observer(FacilityAmbientAnalysis)
